import React, { ChangeEvent, useCallback } from "react";

import { Episode, Show, Week } from "../../models/Shows";

import Form from "react-bootstrap/Form";

import { FormGroupWrapper } from ".";
import moment from "moment";

interface EpisodeFilterSelectProps {
    show: Show;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    episode: number;
}

const EpisodeFilterSelect: React.FC<EpisodeFilterSelectProps> = ({
    onChange,
    episode,
    show,
}) => {
    const createList = useCallback(() => {
        if (show.weeks && show.weeks.length > 0) {
            return show.weeks.map((week: Week) => {
                const episodes = week.episodes;
                if (episodes.length === 0) return null;

                const firstEp = episodes[0];
                const lastEp = episodes[episodes.length - 1];

                const epLabel =
                    episodes.length === 1
                        ? `Ep. ${firstEp.episode_number}`
                        : `Eps. ${firstEp.episode_number}–${lastEp.episode_number}`;

                const firstDate = moment(firstEp.lock_date).format("MM/DD");
                const lastDate = moment(lastEp.lock_date).format("MM/DD");

                const dateLabel =
                    firstDate === lastDate
                        ? firstDate
                        : `${firstDate}-${lastDate}`;

                return (
                    <option key={week.week_number} value={week.week_number}>
                        {`Week ${week.week_number} (${epLabel}, ${dateLabel}${
                            week.week_number === show.current_episode
                                ? ") (current)"
                                : ")"
                        }`}
                    </option>
                );
            });
        } else if (show.episodes_list && show.episodes_list.length > 0) {
            return show.episodes_list.map((episode: Episode) => {
                return (
                    <option
                        key={episode.episode_number}
                        value={episode.episode_number}
                    >
                        {`Episode ${episode.episode_number} - ${moment(
                            episode.lock_date
                        ).format("MM/DD")} ${
                            episode.episode_number === show.current_episode
                                ? " (current)"
                                : ""
                        }`}
                    </option>
                );
            });
        } else {
            return Array.from(
                Array(show.episodes).keys(),
                (episode: number) => {
                    return (
                        <option key={episode + 1} value={episode + 1}>
                            {`${show.type === "week" ? "Week" : "Episode"} ${
                                episode + 1
                            }${
                                episode + 1 === show.current_episode
                                    ? " (current)"
                                    : ""
                            }`}
                        </option>
                    );
                }
            );
        }
    }, [show]);

    return (
        <FormGroupWrapper>
            <Form.Control as="select" onChange={onChange} value={episode}>
                <option value="0">Total Stats</option>
                {createList()}
            </Form.Control>
        </FormGroupWrapper>
    );
};

export default EpisodeFilterSelect;
